var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgPictoIncidentPower(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Calque_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 24 24",
    style: {
      enableBackground: "new 0 0 24 24"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18.9,8c-0.1-0.2-0.3-0.2-0.5-0.2l-5.7,0.8h0l1.2-6c0-0.2-0.1-0.5-0.3-0.6c-0.2-0.1-0.5,0-0.6,0.1L8.8,7.6L7.8,6.7 c-0.2-0.2-0.5-0.2-0.7,0c-0.2,0.2-0.2,0.5,0,0.7l1,1l-3,3.9c-0.1,0.2-0.1,0.4,0,0.5C5.2,13,5.4,13.1,5.6,13l6.3-0.6h0l-1.8,9 c0,0.2,0.1,0.5,0.3,0.6c0.1,0,0.1,0,0.2,0c0.2,0,0.3-0.1,0.4-0.2l4-6.8l2,1.9c0.2,0.2,0.5,0.2,0.7,0c0.2-0.2,0.2-0.5,0-0.7l-2.2-2.1 l3.3-5.6C19,8.4,19,8.2,18.9,8z M8.9,9.1l2.5,2.4l-4.7,0.5L8.9,9.1z M11.6,18.8l1.2-5.9l1.5,1.4L11.6,18.8z M14.8,13.4l-1.9-1.8 c0,0,0-0.1,0-0.1c0-0.1-0.1-0.1-0.2-0.1L9.5,8.3l3-3.8l-0.9,4.6c0,0.2,0,0.3,0.1,0.4c0.1,0.1,0.3,0.2,0.4,0.2l5.4-0.7L14.8,13.4z"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPictoIncidentPower);
export default __webpack_public_path__ + "static/media/picto-incident-power.07f26162.svg";
export { ForwardRef as ReactComponent };